import US_STATE_CODE from '~/enums/us-state-code';
import { isValidState, type StateCode } from '~/services/actions/state-actions';
import TrackingActions, {
	TRACKING_ACTIONS,
	TRACKING_CATEGORIES,
	TRACKING_EVENTS,
	TRACKING_LABELS,
} from '~/services/actions/tracking-actions';
import { promisifiedDelay } from '~/utils/promisifiedDelay';
import { responseIsJson } from '~/utils/responseIsJson';

import {
	HANDLE_INPUT_BLUR,
	HANDLE_INPUT_CHANGE,
	TOGGLE_AGREE_TERMS,
	UPDATE_SUBMIT_STATE,
} from './types';

export default function onboardingActions(dispatch) {
	function toggleTerms() {
		dispatch({ type: TOGGLE_AGREE_TERMS });
	}

	function updateSubmitState(state: boolean) {
		dispatch({ type: UPDATE_SUBMIT_STATE, submit: state });
	}

	function trackSignUp() {
		const trackingService = new TrackingActions();
		trackingService.eventTracking({
			event: TRACKING_EVENTS.SIGN_UP_CONTAINER,
			eventAction: TRACKING_ACTIONS.signupContainer,
			eventCategory: TRACKING_CATEGORIES.ODDSCHECKER_ACCOUNT,
			eventLabel: TRACKING_LABELS.signupContainer,
		});
	}

	async function handleFormSubmit(
		email: string,
		state: StateCode,
		baseUrl: string,
	) {
		updateSubmitState(true);
		trackSignUp();

		const requestOptions: RequestInit = {
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				email,
				state: isValidState(state) ? state : US_STATE_CODE.NJ,
			}),
			method: 'POST',
			mode: 'cors',
		};

		try {
			const response = await fetch(`${baseUrl}register-email`, requestOptions);
			if (responseIsJson(response)) {
				const data = await response.json();
				await promisifiedDelay(5000);
				if (data.success) {
					handleInputChange('');
				}
				updateSubmitState(false);
			}
		} catch (error) {
			console.error('FETCH error: ', error);
			updateSubmitState(false);
		}
	}

	function handleInputChange(value: string) {
		let payload = {
			value: '',
			isValid: false,
		};
		if (value) {
			const regex = /\S+@\S+\.\S+/;
			const isValidEmail = regex.test(value);
			payload = {
				value,
				isValid: isValidEmail,
			};
		}
		dispatch({ type: HANDLE_INPUT_CHANGE, payload });
	}

	function handleInputBlur() {
		dispatch({ type: HANDLE_INPUT_BLUR });
	}

	return {
		toggleTerms,
		handleFormSubmit,
		handleInputChange,
		handleInputBlur,
		updateSubmitState,
	};
}
